module.exports = __webpack_public_path__ + "media/favicons/favicon_180-808c00b34de962e948c2894bbc736a6f.png";